import { useMemo } from 'react';
import { userSelector } from 'slices/auth.slice';
import { useAppSelector } from 'slices/store';
import { calculatePermissions } from 'utils/authentication';
import type { TPermissionRequirements } from '@timeedit/types/lib/types/permissions.type';

/**
 * Returns true when the current user satisfies the given permission
 * requirements (any scope OR any permission match, mirroring
 * `calculatePermissions`). Pass the same shape used elsewhere for permission
 * gating (e.g. visibility config).
 */
export const usePermission = (
  requirements: TPermissionRequirements
): boolean => {
  const authUser = useAppSelector(userSelector);
  return useMemo(
    () => calculatePermissions(authUser, requirements),
    [authUser, requirements]
  );
};
